var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Service, { inject as service } from '@ember/service';
import { action, set, computed } from '@ember/object';
import { PlaidLink } from '@square/dashboard-protos/models/squareup/sfs/external/models/plaid_link';
import { readOnly } from '@ember/object/computed';
import { getLanguageEnumFromLocale } from '@banking/api/utils/language';
import { v4 as uuid } from 'uuid';
import moment from 'moment-timezone';
import environment from '@square/environment-utils/environment';
import { get as getFromLocalStorage, set as setToLocalStorage } from '@square/dashboard-utilities/utils/persistable';
import { SAVINGS_PLAID_GRINGOTTS_SESSION_TOKEN_KEY, SAVINGS_PLAID_OAUTH_LINK_TOKEN_KEY } from '@banking/ui/utils/constants';
import { OneTrustConsent } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
const INSTANTLY_VERIFIED = 'instantly_verified';
let PlaidState = (_dec = readOnly('sfsExternalBankAccountApi.plaidLink'), _dec2 = readOnly('capitalEngineContext.sessionContext.merchantToken'), _dec3 = computed('plaidLink.verificationStatus'), _dec4 = computed('plaidLink.verificationStatus'), _dec5 = computed('plaidLink.createdAt'), _class = class PlaidState extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "features", _descriptor, this);
    _initializerDefineProperty(this, "sfsExternalBankAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor5, this);
    _initializerDefineProperty(this, "sentry", _descriptor6, this);
    _defineProperty(this, "isLoading", false);
    _defineProperty(this, "showError", false);
    _defineProperty(this, "config", void 0);
    _initializerDefineProperty(this, "plaidLink", _descriptor7, this);
    _initializerDefineProperty(this, "customerId", _descriptor8, this);
  }
  init(...args) {
    super.init(...args);
    const plaidConfig = {
      clientName: '',
      product: ['auth'],
      countryCodes: ['US'],
      env: 'sandbox'
    };
    if (environment().isProduction) {
      plaidConfig.env = 'production';
    } else {
      plaidConfig.env = 'sandbox';
    }
    set(this, 'config', plaidConfig);
  }
  get hasVerifyingLink() {
    return this.plaidLink?.verificationStatus ? this.isLinkStatusVerifying(this.plaidLink.verificationStatus) : false;
  }
  get canVerifyAccount() {
    return this.plaidLink?.verificationStatus === PlaidLink.PlaidVerificationStatus.PENDING_MANUAL_VERIFICATION;
  }
  get isLinkLessThanOneDay() {
    if (this.plaidLink) {
      return moment().diff(moment(this.plaidLink.createdAt), 'days') < 1;
    } else {
      return false;
    }
  }
  isLinkStatusVerifying(linkStatus) {
    return linkStatus === PlaidLink.PlaidVerificationStatus.PENDING_AUTOMATIC_VERIFICATION || linkStatus === PlaidLink.PlaidVerificationStatus.PENDING_MANUAL_VERIFICATION;
  }
  async plaidOnSuccess(publicToken, metadata) {
    set(this, 'isLoading', true);
    const id = this.sfsCustomerApi.currentCustomer?.id;
    if (id) {
      try {
        await this.sfsExternalBankAccountApi.linkExternalBankAccountWithPlaid(uuid(), id, publicToken,
        // Our Plaid setup is configured for customers to select a single account,
        // but it is always returned as an array
        metadata.accounts[0].id, metadata.accounts[0].verification_status || INSTANTLY_VERIFIED,
        // if verification status is not provided, it means it was instantly verified
        getFromLocalStorage(SAVINGS_PLAID_GRINGOTTS_SESSION_TOKEN_KEY));
      } catch (error) {
        this.sentry.captureException(error);
      }
    } else {
      throw new Error('must have customer id to call linkExternalBankAccountWithPlaid');
    }
    set(this, 'isLoading', false);
  }
  plaidOnError(error) {
    // Errors from Plaid aren't always instances of Error
    if (error instanceof Error) {
      this.sentry.captureException(error);
    } else {
      const formattedError = new Error('Exception in plaidOnError');
      formattedError.name = 'PlaidError';
      formattedError.message = JSON.stringify(error, Object.getOwnPropertyNames(error));
      this.sentry.captureException(formattedError, {
        extra: {
          originalError: error
        }
      });
    }
    set(this, 'showError', true);
  }
  closeError() {
    set(this, 'showError', false);
  }
  async plaidOnExit(error, _metadata) {
    set(this, 'isLoading', false);
    const id = this.sfsCustomerApi.currentCustomer?.id;
    if (!id) {
      throw new Error('must have customer id to call failPlaidLink');
    }
    if (error) {
      await this.sfsExternalBankAccountApi.failPlaidLink(id, error.error_code);
    }
  }
  async createPlaidLinkToken(isVerifyingManualDeposits = false) {
    const language = getLanguageEnumFromLocale(this.intl.primaryLocale);
    const id = this.sfsCustomerApi.currentCustomer?.id;
    if (id) {
      try {
        set(this, 'isLoading', true);
        const {
          plaidLinkToken,
          gringottsSessionToken
        } = await this.sfsExternalBankAccountApi.createPlaidLinkToken(id, language, isVerifyingManualDeposits);

        // Save the plaid link token and gringotts session token key to local storage for OAuth flows.
        // When the user is redirected back to dashboard these tokens will be retrieved from
        // local storage to complete the link session.
        setToLocalStorage(SAVINGS_PLAID_OAUTH_LINK_TOKEN_KEY, plaidLinkToken, OneTrustConsent.FUNCTIONAL);
        setToLocalStorage(SAVINGS_PLAID_GRINGOTTS_SESSION_TOKEN_KEY, gringottsSessionToken, OneTrustConsent.FUNCTIONAL);
        return plaidLinkToken;
      } catch {
        set(this, 'isLoading', false);
        this.plaidOnError(new Error('could not create plaid link token'));
        return null;
      }
    } else {
      return null;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsExternalBankAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "plaidLink", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "customerId", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "hasVerifyingLink", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "hasVerifyingLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canVerifyAccount", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "canVerifyAccount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isLinkLessThanOneDay", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "isLinkLessThanOneDay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plaidOnSuccess", [action], Object.getOwnPropertyDescriptor(_class.prototype, "plaidOnSuccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plaidOnError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "plaidOnError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeError", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeError"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "plaidOnExit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "plaidOnExit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "createPlaidLinkToken", [action], Object.getOwnPropertyDescriptor(_class.prototype, "createPlaidLinkToken"), _class.prototype), _class);
export { PlaidState as default };